import * as URL from "../helpers/Constants";
import axios from "axios";

export default class PharmacyOwnerService {
    static getAllPharmacyOwners(page, size, name) {
        return axios.get(URL.GET_ALL_PHARMACY_OWNERS, {
            ...PharmacyOwnerService.getAuthHeader(),
            params: {page, size, name}
        });
    }

    static getProductsForPharmacyOwner(page, size) {
        return axios.get(URL.GET_ALL_PRODUCTS_FOR_PHARMACY_OWNER, {
            ...PharmacyOwnerService.getAuthHeader(),
            params: {page, size}
        });
    }

    static addPharmacyOwner(data) {
        return axios.post(URL.POST_PHARMACY_OWNER, data, PharmacyOwnerService.getAuthHeader());
    }

    static updatePharmacyOwner(data, id) {
        return axios.put(`${URL.UPDATE_PHARMACY_OWNER}/${id}`, data, PharmacyOwnerService.getAuthHeader());
    }

    static deletePharmacyOwner(id) {
        return axios.delete(`${URL.DELETE_PHARMACY_OWNER}/${id}`, PharmacyOwnerService.getAuthHeader());
    }

    static getAllPharmaciesForPharmacyOwner(page, size) {
        return axios.get(URL.GET_ALL_PHARMACY_FOR_PHARMACY_OWNER, {
            ...PharmacyOwnerService.getAuthHeader(),
            params: {page, size}
        });
    }

    static addReportLoginLocation(pharmacyId, data) {
        return axios.post(`${URL.APPLY_REPORT_LOCATION_COUPON_URL}/${pharmacyId}`, data, PharmacyOwnerService.getAuthHeader());
    }

    static getUserByPhoneNumber(params) {
        return axios.get(URL.GET_USER_BY_PHONE_NUMBER_URL, {
            ...PharmacyOwnerService.getAuthHeader(),
            params
        });
    }

    static checkDeviceLimit(data) {
        return axios.get(`${URL.CHECK_DEVICE_LIMIT_URL}/${data?.pharmacyId}/${data?.userId}/${data?.deviceId}/${data?.deviceType}`, PharmacyOwnerService.getAuthHeader());
    }

    static getAuthHeader() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        const options = {headers: {"Authorization": `Bearer ${accessToken}`}}
        return options;
    }
}